module.exports = __webpack_public_path__ + "img/Best Practices and Tips Bullet Point.08cc8630.png";